import { combineReducers } from 'redux';

import configReducer from 'src/redux/reducers/config';
import jobAlertsReducer from 'src/redux/reducers/job-alerts';


export default combineReducers({
  configReducer,
  jobAlertsReducer
});
